<script setup lang="ts">
import type { Component } from 'vue';

import LegacyDashboardReportsWidget from '@/components/VisionAi/widgets/LegacyDashboardReportsWidget.vue';
import type { VisionWidget } from '@/components/VisionAi/widgets/visionWidget.types.ts';

withDefaults(
  defineProps<{
    widgets?: VisionWidget[];
  }>(),
  { widgets: () => [] },
);

const WIDGET_COMPONENT_MAP: Record<string, Component> = {
  legacy_dashboards_report: LegacyDashboardReportsWidget,
};

function getWidgetComponent(type: string): Component | undefined {
  return WIDGET_COMPONENT_MAP[type];
}
</script>

<template>
  <template v-for="(widget, index) in widgets" :key="`unified-widget-${index}`">
    <component
      :is="getWidgetComponent(widget.type)"
      v-if="getWidgetComponent(widget.type)"
      :widget-data="widget.data"
    />
  </template>
</template>
